var FieldsetLooks;
(function (FieldsetLooks) {
  FieldsetLooks["Default"] = 'default';
})(FieldsetLooks || (FieldsetLooks = {}));
export { FieldsetLooks };